// AUTO-GENERATED. Do not edit by hand.
// Each form lives in ./forms/{formId}.ts; this file is the barrel.

import type { TvmFormDefinition } from "./types";
import { propulsion } from "./forms/propulsion";
import { towCable } from "./forms/towCable";
import { trawlGate } from "./forms/trawlGate";
import { guinches } from "./forms/guinches";
import { flotation } from "./forms/flotation";
import { cloths } from "./forms/cloths";
import { resistenceExpansion } from "./forms/resistenceExpansion";
import { demeral } from "./forms/demeral";
import { crustacean } from "./forms/crustacean";
import { doubleTow } from "./forms/doubleTow";
import { tripleTow } from "./forms/tripleTow";
import { pair } from "./forms/pair";
import { tangonero } from "./forms/tangonero";

export const FORMS: Record<string, TvmFormDefinition> = {
	propulsion,
	towCable,
	trawlGate,
	guinches,
	flotation,
	cloths,
	resistenceExpansion,
	demeral,
	crustacean,
	doubleTow,
	tripleTow,
	pair,
	tangonero,
};

export type FormId = keyof typeof FORMS;
